module.exports = __webpack_public_path__ + "img/word.7c0bd039.svg";